const support = (
    cmd: string,
    setHistory: React.Dispatch<React.SetStateAction<string[]>>
  ): string[] => {
    return [
      'Support & Resources',
      '',
      '  Need help, tutorials, or updates?',
      '  ✉️ Email: ai-cryptotrading@engineer.com',
      '  📺 YouTube: https://youtube.com/@ai-cryptotrading',
      '',
      '  Get walkthroughs, mining strategies, and wallet tips.',
      '  Stay tuned for more features and guides!',
    ];
  };
  
  export default support;
  